var render = function render(){var _vm=this,_c=_vm._self._c;return _c('svg',{attrs:{"xmlns":"http://www.w3.org/2000/svg","width":"23","height":"80","fill":"none","viewBox":"0 0 23 80"}},[_c('path',{attrs:{"fill":"currentColor","d":"M23 80H8a8 8 0 0 1-8-8V55.154c0-2.21 1.846-3.932 3.918-4.7 4.348-1.61 7.45-5.826 7.45-10.773 0-4.946-3.102-9.162-7.45-10.773C1.846 28.141 0 26.418 0 24.208V8a8 8 0 0 1 8-8h15z"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }